const formatters = {
  default: (value) => value,
};

export default formatters;
